'use client';

import { IBaseComponentProps } from '@actr/specs/src/base-component-props';
import { TitleNames } from '@actr/style/src/specs/theme-v2';
import classNames from 'classnames';
import React, { memo } from 'react';

import { imageObjectJSONLD, organizationJSONLD } from '@/utils/schema-org/organization';

import * as Styled from './style.css';

export interface InnerHtmlTextBlockProps extends IBaseComponentProps {
  title?: string;
  html: string;
}

const InnerHtmlTextBlock: React.FC<InnerHtmlTextBlockProps> = ({ html, className, title }) => {
  let titleText;
  let titleComponent = null;
  let bodyText = html;

  if (title) {
    const startElement = html.slice(1, 3);
    const headingLevel = Object.values(TitleNames).includes(startElement) ? startElement : undefined;
    if (headingLevel) {
      titleText = `<${headingLevel}>${title}</${headingLevel}>`;
      bodyText = html.replace(titleText, '');
      titleComponent = React.createElement(headingLevel, {
        className: classNames(Styled.TitleWrapper({ title: headingLevel }), className),
        itemProp: 'headline'
      }, title);
    }
  }

  return (
    <>
      { titleComponent }
      <div className={classNames(Styled.TextWrapper, className)} itemProp="articleBody" dangerouslySetInnerHTML={{ __html: bodyText }} />
      <div itemProp="author" itemScope>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify([
            organizationJSONLD(),
            imageObjectJSONLD(),
          ]) }}
        />
      </div>
      {// TODO Завести задачу на получение дат публикации и изменения статьи
    /* <meta itemProp="datePublished" content="2025-01-01T08:00:00+03:00" />
    <meta itemProp="dateModified" content="2025-01-01T08:00:00+03:00" /> */}
      <div itemProp="publisher" itemScope>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify([
            organizationJSONLD(),
            imageObjectJSONLD()
          ]) }}
        />
      </div>
    </>
  );
};

export default memo(InnerHtmlTextBlock);
